import React from "react";
import scrollTo from "gatsby-plugin-smoothscroll";

const Footer = () => {
  return (
    <div className="padding font-advent text-1 bg-bg1">
      <div className="border border-text1"></div>
      <div className="text-text1 flex justify-between py-4 tracking-widest">
        <div>©2021, Durcak </div>
        <div onClick={() => scrollTo("#top")} aria-hidden="true" className="underline cursor-pointer">
          back to top
        </div>
      </div>
    </div>
  );
};

export default Footer;
